import { render, staticRenderFns } from "./Edit-ajuda.vue?vue&type=template&id=6dddf041&"
import script from "./Edit-ajuda.vue?vue&type=script&lang=js&"
export * from "./Edit-ajuda.vue?vue&type=script&lang=js&"
import style0 from "./Edit-ajuda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports